
import React from 'react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  ResponsiveContainer,
  Tooltip,
  Legend,
  Cell
} from 'recharts';
import { chartData, CHART_COLORS } from '../data/chartData';

export const AccountBalanceChart = () => {
  return (
    <div className="h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis 
            tickFormatter={(value) => 
              `₹${(value / 10000000).toFixed(1)}Cr`
            } 
          />
          <Tooltip 
            formatter={(value) => 
              [`₹${Number(value).toLocaleString('en-IN')}`, "Amount"]
            } 
          />
          <Legend />
          <Bar dataKey="value" name="Total Balance">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
